import { DeviceId } from "./constants/DeviceId";
import { StoreId } from "./constants/StoreId";
import { CampaignVars } from "../marketing/google/CampaignVars";
import { TimezoneUtil } from "../utils/TimezoneUtil";
import { BasicTrackingEvent } from "./BasicTrackingEvent";

import { Capabilities } from "@goodgamestudios/createjs-utilities";
import { Country } from "@goodgamestudios/world-assignment";

import * as trackingEvents from "@goodgamestudios/tracking-event-types";

export class WorldAssignmentTrackingEvent extends BasicTrackingEvent {
    public accountId: string;
    public campaignVars: CampaignVars;
    public country: Country;
    public deviceId: number = DeviceId.DESKTOP;
    public websiteId: string = "0";
    public storeId: number = StoreId.WEB;
    public geoIpRequestTime: number = 0;
    public countryDetectionFactor: number = 0;

    /**
     * For details of the single tracking parameters see following google doc:
     * https://docs.google.com/a/goodgamestudios.com/spreadsheet/ccc?key=0AlN2EPXCQVModDB1Z2FiTlF6dHVnWjduN1drSUtYa1E#gid=67
     *
     * @param referrer
     */
    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): trackingEvents.WorldAssignment.Event {
        const vars: trackingEvents.WorldAssignment.Event = {
            eventId: trackingEvents.WorldAssignment.ID,
            event_mapping_version: 2,
            accountHash: this.accountId,
            clientTimeZone: TimezoneUtil.getTrackingTimezoneInUTC(),
            deviceId: this.deviceId,
            websiteId: this.websiteId,
            storeId: this.storeId,
            clientCountryCode: this.country.ggsCountryCode,
            browserLang: Capabilities.language
        };

        (<trackingEvents.WorldAssignment.EventWithCommonParameters>vars).lang = this.country.ggsLanguageCode;

        if (this.campaignVars && this.campaignVars.isValid()) {
            vars.partnerId = parseInt(this.campaignVars.partnerId);
            vars.creative = parseInt(this.campaignVars.creative);
            vars.placement = this.campaignVars.placement;
            vars.keyword = this.campaignVars.keyword;
            vars.googleNetwork = this.campaignVars.network;
            vars.lp = parseInt(this.campaignVars.lp);
            vars.cid = this.campaignVars.channelId;
            vars.tid = this.campaignVars.trafficSource;
            vars.aid = parseInt(this.campaignVars.aid);
            vars.camp = parseInt(this.campaignVars.camp);
            vars.adgr = parseInt(this.campaignVars.adgr);
            vars.matchtype = this.campaignVars.matchtype;
        }

        vars.referrer = this.referrer;
        vars.geoIpRequestTime = this.geoIpRequestTime;
        vars.countryDetectionFactor = this.countryDetectionFactor;

        return vars;
    }
}
